import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import * as moment from 'moment';
import { NeworderbankPage } from '../neworderbank/neworderbank';
import { RoutingnalogbankPage } from '../reportorderbank/routingnalogbank';

/**
 * Generated class for the PreorderbankPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-preorderbank',
  templateUrl: 'preorderbank.html',
})
export class PreorderbankPage {
  loadingData: boolean = true
  DataPredefined = []
  _ref
  mdl

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public alertCtrl: AlertController, public modalCtrl: ModalController) {
    this._ref = this.navParams.get('r')
    this.gn.xlsFunction = null
  }

  ionViewDidLoad() {
    this.loadDataPredefined()
  }
  loadDataPredefined() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getpredefinetroutesnlb', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.loadingData = false
      _that.DataPredefined = []
      for (var i = 0; i < _data.length; i++) {
        if (_data[i].cnt >= 2) {
          _data[i].visible = true
          _data[i].distance = parseFloat(_data[i].totalkm).toFixed(1) + ' Km'
          _data[i].time = _that.formatSec(parseInt(_data[i].totaltime))
          _data[i].datum = moment(_data[i].datetime).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].datetime).format(_that.gn.user.TFormat)
          _data[i].npois = _data[i].npois.split("@")
          _data[i].npois1 = _data[i].npois1.split("@")
          _data[i].show = true;
          _that.DataPredefined.push(_data[i])
        }
      }
      _that.gn.xlsFunction = function () {
        _that.createXLS(1, 1)
      }
      //debugger;
    })
  }

  openPredPois(_idx) {
    this.DataPredefined[_idx].show = !this.DataPredefined[_idx].show;
  }

  editPredef(_idx, _id) {
    var _that = this
    this.mdl = this.modalCtrl.create(NeworderbankPage, {
      ref: this, id: _id, edittype: 'pre', preddata: this.DataPredefined[_idx],
      cb: function () {
        setTimeout(() => {
          _that.loadDataPredefined();
        }, 1000);
      }
    }, { cssClass: "modal-fullscreen" }
    );
    this.mdl.present()

    // this.gn.routeBankEditId = _id
    // this.gn.routeBankFunction()
    // console.log(this._ref)
    // ref.doSelectMeu(1)
    // console.log(this.navCtrl.getActive())
  }

  delPredef(_id, _idx) {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deletespredroute"],
      subTitle: _that.dic.l["areyousuredelpredroute"],
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            var _that = this;
            this.gn._Post('/api/gn/delpredefroute', { id: this.gn.crypt(_id) }, function (_data) {
              _that.DataPredefined.splice(_idx, 1);
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }
  isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  showOnMap(_idx, _id) {
    var _that = this
    this.gn._Post('/api/gn/getroutesOneBank', { pre: this.gn.crypt('1'), cid: this.gn.crypt(this.gn.user.ClientId), nid: this.gn.crypt(_id) }, function (_data) {
      console.log(_data, 'daj da vidam data')
      let profileModal = _that.modalCtrl.create(RoutingnalogbankPage, {
        cb: function (_id) {
        }, rid: _id, pois: _data
      });
      profileModal.present();
    })

  }

  createXLS(_idx, _id) {
    var xlsJsoon = {
      Sheets: []
    }

    var sheet = {
      Title: this.DataPredefined[_idx].name,
      SubTitle: '',
      SubTitles: [
        this.dic.l["Client"] + ': ' + this.gn.user.ClientName,
        this.dic.l["user"] + ': ' + this.gn.user.UserFullName,
        this.dic.l["Datetime"] + ': ' + moment().format(this.gn.user.DFormat) + ' ' + moment().format(this.gn.user.TFormat)
      ],
      tables: [

      ]
    }
    // if (drv.nodata != 1) {
    //   for (var j = 0; j < drv.data.length; j++) {
    // var gr = drv.data[j]
    var dt = []
    //if (gr.listdist.length == 0) {
    // gr.listdist.push({ fuel: 0, distance: 0, veh: '/' })
    //}
    for (let c = 0; c < this.DataPredefined[_idx].npois1.length; c++) {
      var tmp = [c + 1, this.DataPredefined[_idx].npois1[c].split("#")[1]]
      dt.push(tmp)
    }

    var tbl = {
      Title: this.dic.l["CreatedOn"] + ' ' + this.DataPredefined[_idx].datum + ' ' + this.dic.l["by"] + ' ' + this.DataPredefined[_idx].username,
      Cols: [
        { text: this.dic.l['No.'], type: 'n', width: 10, align: 'center' },
        { text: this.dic.l['poione'], type: 'n', width: 65, align: 'left' },
      ],
      Data: dt
    }
    sheet.tables.push(tbl)

    //   }
    // }
    xlsJsoon.Sheets.push(sheet)
    //}
    this.gn.prepareXLS(xlsJsoon, this.DataPredefined[_idx].name, false)
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/preorderbank/preorderbank.ts